import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-youtube-tip-modal',
  templateUrl: './youtube-tip-modal.component.html',
  styleUrls: ['./youtube-tip-modal.component.scss'],
})
export class YoutubeTipModalComponent implements OnInit {
  constructor(private modalRef: MatDialogRef<YoutubeTipModalComponent>) {}

  close(r: any = null) {
    this.modalRef.close(r);
  }

  ngOnInit(): void {}
}
